<div class="small-spinner" *ngIf="showSpinner">
  <mat-progress-spinner
    mode="indeterminate"
    [diameter]="spinnerDiameter"
    [strokeWidth]="3">
  </mat-progress-spinner>
</div>
